import axios from '@/utils/request'
const urlPrefix = 'system'
const urlPrefix2 = 'oauth'

// 获取团队下拉列表
export function teamListSelect () {
  return axios({
    url: urlPrefix + '/team/list',
    method: 'GET'
  })
}

// 切换团队更新数据
export function switchTeam (data) {
  return axios({
    url: urlPrefix2 + '/oauths/switch/team',
    method: 'POST',
    data
  })
}

// 查询当前登录人在该团队角色
export function roleByTeamId (params) {
  return axios({
    url: urlPrefix + '/teamUser/selectCurrentUserRoleByTeamId',
    method: 'GET',
    params
  })
}

// 获取团队列表
export function teamList (params) {
  return axios({
    url: urlPrefix + '/team/user/page',
    method: 'GET',
    params
  })
}

// 创建团队
export function createTeam () {
  return axios({
    url: urlPrefix + '/team',
    method: 'POST'
  })
}

// 修改团队名称
export function updateTeamName (data) {
  return axios({
    url: urlPrefix + '/team',
    method: 'PUT',
    data
  })
}

// 解散团队
export function dissolveTeamApi (data) {
  return axios({
    url: urlPrefix + '/team/dissolve',
    method: 'PUT',
    data
  })
}

// 退出团队
export function exitTeamApi (params) {
  return axios({
    url: urlPrefix + '/teamUser/exitTeam',
    method: 'DELETE',
    params
  })
}

// 团队拖拽
export function teamMove (data) {
  return axios({
    url: urlPrefix + '/teamUser/move',
    method: 'PUT',
    data
  })
}

// 移交团队
export function handoverTeam (data) {
  return axios({
    url: urlPrefix + '/team/handover',
    method: 'POST',
    data
  })
}

// 成员列表
export function userList (params) {
  return axios({
    url: urlPrefix + '/teamUser/handOverTeamUserlist',
    method: 'GET',
    params
  })
}

// 生成分享串
export function teamShare (data) {
  return axios({
    url: urlPrefix + '/link',
    method: 'POST',
    data
  })
}

// 根据分享串获取分享配置
export function inviterMsg (params) {
  return axios({
    url: urlPrefix + '/link/noncestr',
    method: 'GET',
    params
  })
}

// 邀请成员
export function inviteMemberApi (data) {
  return axios({
    url: urlPrefix + '/teamUser',
    method: 'POST',
    data
  })
}

// 删除成员
export function deleteMemberApi (id) {
  return axios({
    url: urlPrefix + '/teamUser/delete/' + id,
    method: 'DELETE'
  })
}

// 编辑成员角色
export function editMemberRole (data) {
  return axios({
    url: urlPrefix + '/teamUser',
    method: 'PUT',
    data
  })
}

// 监测当前用户是否在该团队中
export function detectTeam (data) {
  return axios({
    url: urlPrefix + '/teamUser/userInTeam',
    method: 'POST',
    data
  })
}
